// extracted by mini-css-extract-plugin
module.exports = {"render":"SMCAnalytics_render__4dGRr","currentPageButton":"SMCAnalytics_currentPageButton__37cmq","nextPageButton":"SMCAnalytics_nextPageButton__10pl5"};